module.exports = __webpack_public_path__ + "img/about-thaw.6a023da5.jpg";